export default "c8a7310529d87335.svg"